class Report {
  constructor({ url }) {
    this.url = url;
  }
}
export default Report;
